export function ReadIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_221_6394)">
        <path
          d="M11.7333 3.5H6.5C4.84315 3.5 3.5 4.84315 3.5 6.5V13.5C3.5 15.1569 4.84315 16.5 6.5 16.5H13.5C15.1569 16.5 16.5 15.1569 16.5 13.5V8.26667"
          stroke="current"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
        <path
          d="M16.8298 4.07878L10.6778 10.8143C10.6242 10.8731 10.5605 10.9199 10.4904 10.9517C10.4203 10.9836 10.3452 11 10.2693 11C10.1934 11 10.1182 10.9836 10.0481 10.9517C9.97798 10.9199 9.91431 10.8731 9.86073 10.8143L7.16922 7.86749C7.11557 7.80876 7.07301 7.73902 7.04398 7.66228C7.01494 7.58554 7 7.50328 7 7.42022C7 7.33715 7.01494 7.25489 7.04398 7.17815C7.07301 7.1014 7.11557 7.03167 7.16922 6.97294C7.22287 6.9142 7.28656 6.8676 7.35666 6.83582C7.42675 6.80403 7.50188 6.78767 7.57775 6.78767C7.65362 6.78767 7.72875 6.80403 7.79885 6.83582C7.86895 6.8676 7.93264 6.9142 7.98629 6.97294L10.2697 9.47296L16.0137 3.18527C16.1221 3.06664 16.269 3 16.4222 3C16.5755 3 16.7224 3.06664 16.8308 3.18527C16.9391 3.30389 17 3.46479 17 3.63255C17 3.80031 16.9391 3.9612 16.8308 4.07983L16.8298 4.07878Z"
          fill="current"
        />
      </g>
      <defs>
        <clipPath id="clip0_221_6394">
          <rect width="20" height="20" fill="current" />
        </clipPath>
      </defs>
    </svg>
  );
}
